import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable()
export class LoginRedirect implements CanActivate {
  canActivate(): boolean {
    return true;
  }
}
